module.exports = __webpack_public_path__ + "static/media/shirts5.f3b883f7.jpg";